module.exports = __webpack_public_path__ + "img/standardModel-icon-seedselector.e4bcaaa0.svg";